<template>
  <div>
    <ts-dialog title="" :visible.sync="visible" width="800px" center :show-close="false" v-if="activeAsset">
      <div class="border-b border-white py-2" style="margin-top: -2rem">
        <h1 class="text-center mb-3">Publish to The Source</h1>
        <p class="text-center">File {{ activeAssetPosition }} of {{ deliverables.length }}</p>
      </div>
      <div class="py-4">
        <div class="grid grid-cols-3 gap-4">
          <div class="col-span-1">
            <div class="py-10 bg-gray-100 border px-2 border-white bg-gray-100 rounded-sm flex flex-col items-center">
              <div class="mb-4">
                <video :src="activeAssetUrl" v-if="isCurrentAssetVideo" controls style="max-width: 100%;">
                  Your browser does not support the video tag.
                </video>
                <img
                  :src="activeAssetUrl"
                  v-if="isCurrentAssetImage"
                  alt=""
                  class="rounded-sm"
                  style="width: 196px; height: 324px; background: red; max-width: 100%"
                />
              </div>
              <div class="">
                <p class="text-center text-gray-900">{{ activeAsset.name }}</p>
                <!-- <p class="text-center text-gray-500">by @username</p> -->
              </div>
            </div>
          </div>
          <div class="col-span-2">
            <section class="mb-7">
              <h2 class="text-black mb-4 font-semibold text-xl">1. Tag your content with relevant information</h2>
              <div class="mb-2 bg-gray-100 border border-white rounded flex items-center justify-between py-2 px-2"
                   :class="[hasError('brands') ? 'has-error' : '']">
                <div class="flex items-center justify-center">
                  <label for="" class="text-xl px-2 font-light">Brands :</label>
                </div>
                <div class="">
                  <MultiSelectionDropdown
                    placeholder="Brands"
                    text-filter
                    show-picture
                    :width="234"
                    :options="brands"
                    :value="activeAsset.brands"
                    :read-only-single-option="false"
                    @input="handleFilterChange('brands', $event)"
                  ></MultiSelectionDropdown>
                </div>
              </div>
              <div class="error-message" v-if="hasError('brands')">
                {{ activeAsset.errors.brands[0] }}
              </div>
              <div style="margin: 10px 0 20px 15px;">If you can't find the brand, send an email to : <a href="mailto:access@thesource.social">access@thesource.social</a> and brand will be created within a few hours</div>
              <div class="mb-2 bg-gray-100 border border-white rounded flex items-center justify-between py-2 px-2"
                   :class="[hasError('industries') ? 'has-error' : '']">
                <div class="flex items-center justify-center">
                  <label for="" class="text-xl px-2 font-light">Industries :</label>
                </div>
                <div class="">
                  <MultiSelectionDropdown
                    placeholder="Industy types"
                    text-filter
                    show-picture
                    :width="234"
                    :options="industryTypes"
                    :value="activeAsset.industries"
                    :read-only-single-option="false"
                    @input="handleFilterChange('industries', $event)"
                  ></MultiSelectionDropdown>
                </div>
              </div>
              <div class="error-message" v-if="hasError('industries')">
                {{ activeAsset.errors.industries[0] }}
              </div>
              <div class="mb-2 bg-gray-100 border border-white rounded flex items-center justify-between py-2 px-2"
                   :class="[hasError('productions') ? 'has-error' : '']">
                <div class="flex items-center justify-center">
                  <label for="" class="text-xl px-2 font-light">Production type :</label>
                </div>
                <div class="">
                  <MultiSelectionDropdown
                    placeholder="Productions types"
                    text-filter
                    show-picture
                    :width="234"
                    :options="productionTypes"
                    :value="activeAsset.productions"
                    :read-only-single-option="false"
                    @input="handleFilterChange('productions', $event)"
                  ></MultiSelectionDropdown>
                </div>
              </div>
              <div class="error-message" v-if="hasError('productions')">
                {{ activeAsset.errors.productions[0] }}
              </div>
              <div class="mb-2 bg-gray-100 border border-white rounded flex items-center justify-between py-2 px-2"
                   :class="[hasError('creativeTechnics') ? 'has-error' : '']">
                <div class="flex items-center justify-center">
                  <label for="" class="text-xl px-2 font-light">Creative tech :</label>
                </div>
                <div class="">
                  <CustomMultiSelectionDropdown
                    placeholder="Creative techn"
                    :grouped="true"
                    :width="234"
                    :parents="creativeTechnic"
                    :options="creativeTechnic"
                    :value="activeAsset.creativeTechnics"
                    :read-only-single-option="false"
                    @input="handleFilterChange('creativeTechnics', $event)"
                  ></CustomMultiSelectionDropdown>
                </div>
              </div>
              <div class="error-message" v-if="hasError('creativeTechnics')">
                {{ activeAsset.errors.creativeTechnics[0] }}
              </div>
            </section>
            <section class="mb-4">
              <h2 class="text-black mb-4 font-semibold text-xl">2. Set the publication date</h2>
              <div
                class="
                  mb-2
                  bg-gray-100
                  border border-white
                  rounded-sm
                  flex flex-col
                  items-center
                  justify-between
                  py-4
                  px-4
                "
                :class="[hasError('publishedAt.dates') ? 'has-error' : '']"
              >
                <div class="mb-4 flex-auto w-full">
                  <label for="" class="text-xl px-2 font-light">Publication date :</label>
                </div>
                <div class="flex items-center justify-between w-full">
                  <div class="">
                    <label for="" class="" style="display:block;margin-bottom: -5px; font-size: 14px">Date</label>
                    <ts-form-item>
                      <DatePickerDropdown mode="date" v-model="activeAsset.publishedAt.dates" placeholder="Date"
                                          :width="200">
                        <template #icon>
    <span style="display:inline-block; margin-right:10px;">
      <ts-icon icon="calendar" title="Clock" size="small"/>
    </span>
                        </template>
                      </DatePickerDropdown>
                    </ts-form-item>
                  </div>
                </div>
              </div>
              <div class="error-message" v-if="hasError('publishedAt.dates')">
                {{ activeAsset.errors['publishedAt.dates'][0] }}
              </div>
            </section>
          </div>
        </div>
      </div>
      <div slot="footer" class="flex items-center justify-center">
        <div class="font-semibold mr-4" v-if="!isFirstItem">
          <ts-button class="font-semibold" :loading="publishing" :disabled="publishing" @click="handlePreviousAsset">
            Previous
          </ts-button>
        </div>
        <div class="font-semibold" v-if="!isLastItem">
          <ts-button class="font-semibold" size="normal" :loading="publishing" :disabled="publishing"
                     @click="handleNextAsset">Next
          </ts-button>
        </div>
        <div class="font-semibold" v-if="isLastItem">
          <ts-button class="font-semibold" type="primary" :loading="publishing" :disabled="publishing" filled
                     @click="handlePublishAssets">Submit
          </ts-button>
        </div>
      </div>
    </ts-dialog>
    <ts-button
      ref="shareButton"
      type="primary"
      size="small"
      filled
      @click="handleOpenDialogButtonClick"
      v-if="hasPublishableAssets"
    >
      Publish to The Source
    </ts-button>
    <AssetsPublishedToTheSourceDialog/>
  </div>
</template>

<script>
import {required} from 'vuelidate/lib/validators';
import {mapState, mapActions} from 'vuex';
import MultiSelectionDropdown from '@/components/inputs/MultiSelectionDropdown.vue';
import CustomMultiSelectionDropdown from '@/components/inputs/CustomMultiSelectionDropdown.vue';
import DatePickerDropdown from '@/components/inputs/DatePickerDropdown.vue';
import TimePicker from '@/components/the-source-ui/TheSourceTimePicker.vue';
import UserPicker from '@/components/inputs/UserPicker.vue';
import TagPickerDropdown from '@/components/inputs/TagPickerDropdown.vue';
import Rating from '@/components/widgets/Rating.vue';
import projectViewHelpers from '@/mixins/projectViewHelpers';
import AssetsPublishedToTheSourceDialog from '@/components/widgets/AssetsPlublishedToTheSourceDialog.vue';

export default {
  name: 'PublishToThesource',
  mixins: [projectViewHelpers],
  components: {
    DatePickerDropdown,
    AssetsPublishedToTheSourceDialog,
    CustomMultiSelectionDropdown,
    MultiSelectionDropdown,
    TagPickerDropdown,
    UserPicker,
    TimePicker,
    Rating
  },
  props: {
    assets: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false,
      publishing: false,
      myTags: [],
      publishables: [],
      activeAssetIndex: 0,
      currentAsset: null,
      form: {
        email: '',
        message: ''
      }
    };
  },
  validations: {
    form: {
      email: {
        required
      },
      message: {}
    }
  },
  computed: {
    ...mapState('workflow', {
      brands: state => state.accessBrands.items.map(b => ({...b, _id: b.id, id: b.slug})),
      industryTypes: state => state.industryTypes.items.map(b => ({...b, _id: b.id, id: b.slug})),
      productionTypes: state => state.myProjects.options.productionTypes.map(b => ({...b, _id: b.id})),
      creativeTechnic: state => state.creativeTechnic.items,
      campaignObjectives: state => state.campaignObjectives.items.map(b => ({...b, _id: b.id, id: b.slug})),
      creators: state => state.creators.items,
      regions: state => state.regions.items.map(b => ({...b, _id: b.id, id: b.slug})),
      currentProjectId: state => state.currentProjectId + '',
      currentProject: state => state.currentProject.value
    }),
    brandsSlug() {
      return this.brands.map(b => b.slug)
    },
    activeAssetCreatorName() {
      return this.activeAsset.creator[0]?.name
    },
    hasPublishableAssets() {
      return this.assets.some(a => a.status !== 'pending' && a.publications.length == 0 && !this.isZipFile(a.file?.originalUrl));
    },
    deliverables() {
      return this.publishables.filter(i => !this.isZipFile(i.file?.originalUrl));
    },
    activeAsset() {
      return this.currentAsset;
    },
    activeAssetPosition() {
      return this.activeAssetIndex + 1;
    },
    isFirstItem() {
      return this.activeAssetIndex === 0;
    },
    isLastItem() {
      return this.publishables.length === this.activeAssetPosition;
    },
    isCurrentAssetVideo() {
      const pieces = this.activeAsset?.file?.originalUrl.split('.') || [];
      return ['mp4', 'mov', 'avi'].includes(pieces.pop());
    },
    isCurrentAssetImage() {
      const pieces = this.activeAsset?.file?.originalUrl.split('.') || [];
      return ['jpg', 'jpeg', 'png', 'git'].includes(pieces.pop());
    },
    activeAssetUrl() {
      return this.activeAsset?.file?.originalUrl;
    }
  },
  mounted() {
    this.fetchExternalBrands();
    this.fetchCreators();
    //this.fetchCommunicationObjectives();
    this.fetchCampaignObjectives();
    this.fetchCreativeTechnic();
    this.fetchRegions();
    this.fetchIndustryTypes();
  },
  methods: {
    ...mapActions('workflow', ['fetchUsers', 'fetchExternalBrands', 'fetchCreators', 'fetchProductionTypes', 'fetchProjectOptions', 'fetchCommunicationObjectives', 'fetchCampaignObjectives', 'fetchCreativeTechnic', 'fetchRegions', 'fetchIndustryTypes', 'publishAssetsToAccess']),
    ...mapActions('workflow/delivery', [
      'replaceFinalAsset',
    ]),
    handleCreatorList() {
    },
    copy() {
      this.$emit('copy');
    },
    async handlePublishAssets() {
      if (!this.validate()) return;
      this.publishing = true;
      try {
        for (let i = 0; i < this.publishables.length; i++) {
          this.showInfo(`Publishing final asset ${i + 1} of ${this.publishables.length}`)
          const payload = await this.publishAssetsToAccess({
            ...(this.publishables[i]),
            projectId: this.currentProjectId
          });
          this.replaceFinalAsset(payload);
          this.publishables[i].published = true;
        }
        this.visible = false;
        this.currentAsset = null;
        this.activeAssetIndex = 0;
        window.EventBus.$emit('Delivery.assets.published');
      } catch (err) {
        this.publishables = this.publishables.filter(b => !b.published);
        this.activeAssetIndex = 0;
        this.currentAsset = this.publishables[this.activeAssetIndex];

        if (!err.response) {
          return;
        }

        this.currentAsset.errors = err.response.data?.errors || {};
        this.showError(err.response.data.message);
      }
      this.publishing = false;
    },
    handleActiveAssetCreatorChange(input) {
      this.activeAsset.creator = input;
    },
    validate() {
      let errors = {};

      if (this.activeAsset.creativeTechnics.length == 0) {
        errors.creativeTechnics = ['The creative technics is required'];
      }

      if (this.activeAsset.productions.length == 0) {
        errors.productions = ['The production is required'];
      }

      if (this.activeAsset.industries.length == 0) {
        errors.industries = ['The industries is required'];
      }

      if (this.activeAsset.creator.length == 0) {
        errors.creator = ['The creator is required'];
      }

      this.activeAsset.errors = errors;

      return Object.keys(errors).length == 0;
    },
    hasError(field) {
      return this.activeAsset.errors[field] != null;
    },
    handleNextAsset() {
      if (!this.validate()) return;
      if (this.activeAssetPosition >= this.deliverables.length) return;

      this.activeAssetIndex++;
      this.currentAsset = this.publishables[this.activeAssetIndex];
    },
    handlePreviousAsset() {
      if (this.activeAssetIndex <= 0) return;

      this.activeAssetIndex--;
      this.currentAsset = this.publishables[this.activeAssetIndex];
    },
    handleFilterChange(field, value) {
      this.activeAsset[field] = value;
    },
    async handleOpenDialogButtonClick() {
      if (this.assets.length == 0) {
        return;
      }
      await Promise.all([this.fetchExternalBrands(), this.fetchProjectOptions()]);
      const dueDate = this.currentProject.dueDate ? new Date(Date.parse(this.currentProject.dueDate)) : new Date();
      dueDate.setDate(dueDate.getDate() + 15);
      const creatorData = [{
        id: '5af7bb032239c21bf345c0a2',
        name: 'The source',
        email: 'mc+test2@thesource.social'
      }];
      this.publishables = this.assets.filter(a => a.publications.length == 0).map(asset => {
        return {
          ...asset,
          publishOn: 'everywhere',
          rating: 3,
          brands: this.currentProject.brands.map(b => b.slug).filter(b => this.brandsSlug.includes(b)),
          creator: creatorData,
          industries: this.currentProject.industry ? [this.currentProject.industry] : [],
          productions: this.currentProject.productionType ? [this.currentProject.productionType] : [],
          regions: this.currentProject.country ? [this.currentProject.country] : [],
          creativeTechnics: [],
          communications: [],
          publicationDate: null,
          published: false,
          errors: {},
          publishedAt: {
            dates: new Date()
          },
          url: this.activeAssetUrl
        };
      });
      this.activeAssetIndex = 0;
      this.currentAsset = this.publishables[this.activeAssetIndex];
      this.visible = true;
    },
    resetForm() {
      this.form = {
        email: '',
        message: ''
      };

      this.$v.$reset();
    },
    skip() {
      this.visible = false;
      this.resetForm();
    },
    handleSaveClick() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit('input', this.form);
        this.visible = false;
        this.resetForm();
      }
    }
  }
};
</script>

<style lang="scss" scoped>

.error-message {
  color: #EF4444;
  font-size: .75rem;
  display: block;
  padding: 0 1rem;
  margin-bottom: .5rem;
}

.has-error {
  border-color: #EF4444 !important;
}

.flex-auto {
  flex: auto;
}

.w-full {
  width: 100%;
}

.mr-4 {
  margin-right: 1rem;
}

.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.mb-3 {
  margin-bottom: 0.75rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mb-7 {
  margin-bottom: 1.75rem;
}

.mr-6 {
  margin-right: 1.25rem;
}

.text-black {
  color: black;
}

.font-light {
  font-weight: 500;
}

.font-semibold {
  font-weight: 500;
}

.text-large {
  font-size: 1.1rem;
}

.text-xl {
  font-size: 1rem;
}

.grid {
  display: grid;
}

.grid-cols-3 {
  grid-template-columns: repeat(3, 1fr);
}

.col-span-2 {
  grid-column: span 2 / span 2;
}

.col-span-1 {
  grid-column: span 1 / span 1;
}

.gap-4 {
  column-gap: 1rem;
}

.text-center {
  text-align: center;
}

.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.border {
  border-width: 1px;
  border-style: solid;
}

.border-b {
  border-bottom-width: 1px;
}

.border-white {
  border-color: white;
}

.bg-gray-100 {
  background: rgba(255, 255, 255, 0.16);
}

.rounded-sm {
  border-radius: 16px;
}

.rounded {
  border-radius: 50px;
}

.text-gray-900 {
  color: #6d7587;
}

.pt-2 {
  padding-top: .5rem;
}

.text-gray-500 {
  color: #acbacc;
}

.row {
  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.16);
  box-shadow: -2px -2px 6px 0 rgba(250, 251, 255, 0.48), 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
  border-radius: 16px;
  margin-bottom: 10px;

  display: flex;
  align-items: center;
  padding: 22px 18px;

  .checkbox {
    margin-right: 13px;
  }

  .file-info {
    width: 400px;
  }

  .file-name {
    font-family: Roboto;
    font-size: 16px;
    color: #6d7587;
  }

  .file-creation-info {
    font-family: Roboto;
    font-size: 10px;
    line-height: 16px;
    color: #acbacc;
  }

  .files {
    flex-grow: 1;
  }

  .actions {
    display: flex;
    align-items: center;

    > * {
      margin-left: 10px;
    }
  }
}

.flex {
  display: flex;
}

.flex-col {
  flex-direction: column;
}

.justify-center {
  justify-content: center;
}

.items-center {
  align-items: center;
}

.mb-2 {
  margin-bottom: 0.5em;
}

.flex-1 {
  flex: auto;
}

.flex-none {
  flex: none;
}

.px-2 {
  padding-left: 0.5em;
  padding-right: 0.5em;
}

.font-semibold {
  font-weight: 600;
}

.uppercase {
  text-transform: uppercase;
}

.py-2 {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}

.justify-between {
  justify-content: space-between;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
